import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Nur Deutsch wird initial gebundlet (Standardsprache). en/fr liegen als eigene
// Chunks und werden erst beim Sprachwechsel per import() nachgeladen — spart ~128 KB
// (roh) im Initial-Bundle. Bis eine Sprache geladen ist, greift fallbackLng "de".
import deTranslation from '../language/de.json';

const loaders = {
  en: () => import('../language/en.json'),
  fr: () => import('../language/fr.json'),
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: deTranslation }
    },
    lng: "de", // Standard-Sprache
    fallbackLng: "de", // Fallback-Sprache
    interpolation: {
      escapeValue: false
    }
  });

// Sprache setzen und Ressourcen bei Bedarf nachladen.
export async function loadLanguage(lng) {
  if (loaders[lng] && !i18n.hasResourceBundle(lng, 'translation')) {
    const mod = await loaders[lng]();
    i18n.addResourceBundle(lng, 'translation', mod.default, true, true);
  }
  await i18n.changeLanguage(lng);
}

export default i18n;
